import { HeritageBuildingHomeUiOuterStucture } from "./HeritageBuildingHome";

const HeritageBuildingHome2 = () => (
  <HeritageBuildingHomeUiOuterStucture currentPage={2}>
    <h5 className="fontSizeClass">
      <strong>(e) Change of use of the Heritage Building :</strong>
    </h5>
    <p>
      Heritage Conservation Committee may consider change of use. The proposed
      change of use shall be in terms of the Act and Rules and Regulations of
      the Kolkata Municipal Corporation.
    </p>
    <h5>(f) Restriction on the display of signage, hoardings etc.</h5>
    <p>
      Normally no display of signage, hoardings etc. upon the heritage building
      is allowed. However, on approval from the Heritage Conservation Committee
      hoardings, signage etc. may be allowed if they do not obstruct the view of
      the heritage building or is in harmony with the heritage building.
    </p>
    <h5>
      (g) Restriction for use of material for repairing / addition / alteration.
    </h5>
    <p>
      Repairing /addition/alteration works shall be done through traditional
      building materials and construction technique. Any kind of use of new
      material shall be done with the approval of the Heritage Conservation
      Committee on recommendation of the enlisted Conservation architect.
    </p>
    <h5>(h) Benefits of being a Heritage Building.</h5>
    <p>
      It will enhance the valuation of the property if properly maintained. One
      can avail oneself of the national or international funds for the
      maintenance of such heritage buildings if properly approached through
      Conservation Architect. Compatible re-use of the building may be permitted
      for commercial benefits. In some special cases property tax may be reduced
      / exempted under Section 425 K of KMC Act, 1980.
    </p>
    <h5>(i)Contact persons for further information</h5>
    <p>
      Director General <br />
      Project Management Unit -<br />
      48, Market Street <br />
      Kolkata - 700087 <br />
      Phone No. 2252-1721
    </p>
    <h5>Preservation and Conservation of Heritage Buildings</h5>
    <p>
      <strong>
        425A. Owner to maintain, preserve and conserve heritage building :
      </strong>
      Every owner or occupier of any heritage building declared as such by the
      Corporation shall maintain, preserve and conserve it and shall not change
      its use in contravention of the provisions of this Act or the rules or the
      regulations made thereunder for its maintenance, preservation or
      conservation.
    </p>
    <h5>
      425B. Power of Corporation to declare a building as a heritage building :
    </h5>
    <p>
      Where the Corporation, on the recommendation of the Heritage Conservation
      Committee and also of the Mayor-in-Council, is of the opinion that any
      building in Calcutta should be preserved and conserved for historical,
      architectural, environmental or ecological purpose, it may declare such
      building as a heritage building : Provided that during the period when any
      proposal for declaring building as a heritage building is under
      consideration of the Heritage Conservation Committee or the
      Mayor-in-Council, no owner of such building, or no lessee or sub-lessee to
      whom such building has been leased out, shall transfer such building by
      way of sale, lease , or mortgage without the prior approval of the
      Municipal Commissioner.
    </p>
    <h5>425C. Gradation of heritage building :</h5>
    <p>
      The gradation of a heritage building according to its historical,
      architectural, environmental or ecological purpose shall be such as may be
      prescribed.
    </p>
    <h5>425D. Heritage Conservation Committee :</h5>
    <ol className="kmc-function-list">
      {[
        {
          label:
            "The Mayor-in-Council shall constitute a Committee to be called the Heritage Conservation Committee with the Municipal Commissioner as its Chairman and an officer of the Corporation as its Convenor.",
          children: [],
        },
        {
          label:
            "The Committee shall have, in addition to the Chairman and the Convenor, seven other members of whom -",
          children: [
            "one shall be a nominee of the Calcutta Metropolitan Development Authority.",
            "one shall be the Director of the Department of Archaeology, Government of West Bengal, or his nominee.",
            "one shall be an eminent architect,",
            "one shall be an artist,",
            "one shall be an environmentalist,",
            "one shall be a historian, and",
            "one shall be the Chief Valuer and Surveyor of the Corporation.",
          ],
        },
        {
          label:
            "The Committee may co-opt one person to be nominated by the concerned department of the State Government while dealing with any land or building under the management of the said department.",
          children: [],
        },
        {
          label:
            "The Committee shall, in accordance with the provisions of this Act and the rules and the regulations made thereunder, scrutinize every application or proposal for declaration of a building as a heritage building, and recommend to, and also advice, the Mayor-in-Council in respect of the preservation and conservation of such building as a heritage building.",
          children: [],
        },
        {
          label:
            "The Committee shall meet at such periodical interval as may be determined by the Mayor-in-Council.",
          children: [],
        },
        {
          label:
            "The Municipal Commissioner shall, in the case of emergency, take such measures as may be necessary for the preservation and conservation of a heritage building, provided that such measures shall be required to be approved by the Heritage Conservation Committee at its meeting.",
          children: [],
        },
      ].map(({ label, children }, index) => (
        <li>
          {label}
          {children.length > 0 && (
            <ol type="a">
              {children.map((child, childIndex) => (
                <li key={childIndex}>{child}</li>
              ))}
            </ol>
          )}
        </li>
      ))}
    </ol>
  </HeritageBuildingHomeUiOuterStucture>
);

export default HeritageBuildingHome2;
